<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Ranger Id" [matTooltipDisabled]="disabledTooltip(this.rangerId)">
          <mat-label i18n="@@type.RangerFirearmAssignmentLog.rangerId">Ranger Id</mat-label>
          <input matInput formControlName="rangerId" id="rangerId" [ngModel]="item.rangerId" #rangerId maxlength="255"
            placeholder="Ranger Id" disabled>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Business Unit from the list"
          [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.RangerFirearmAssignmentLog.businessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnit" [ngModel]="item.businessUnit" #businessUnit
            placeholder="Business Unit" [disabled]="true" [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnitDisplay(businessUnit)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Ranger from the list" [matTooltipDisabled]="disabledTooltip(this.ranger)">
          <mat-label i18n="@@type.RangerFirearmAssignmentLog.ranger">Ranger</mat-label>
          <mat-select formControlName="ranger" id="ranger" [ngModel]="item.ranger" #ranger placeholder="Ranger"
            [disabled]="true" [compareWith]="rangerCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let ranger of rangerSelectionList" [value]="ranger">
              {{rangerDisplay(ranger)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Current Firearm Count"
          [matTooltipDisabled]="disabledTooltip(this.currentFirearmCount)">
          <mat-label i18n="@@type.RangerFirearmAssignmentLog.currentFirearmCount">Current Firearm Count</mat-label>
          <input matInput formControlName="currentFirearmCount" id="currentFirearmCount"
            [ngModel]="item.currentFirearmCount" #currentFirearmCount type="number" placeholder="Current Firearm Count"
            disabled>
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>
  </form>

  <div class="crud-item-section">
    <app-firearm-assignment-list [items]="item.assignments"></app-firearm-assignment-list>
  </div>
</div>